<app-assign-modal-content
    [activeModal]="activeModal"
    [assignmentCode]="assignmentCode"
    [assignmentName]="assignmentName"
    [assignmentHasLti]="assignmentHasLti"
    [type]="type"
></app-assign-modal-content>
